<div class="toolbar">
  <button matButton="text" [disabled]="isBusy()" (click)="backToPersonDetail()">
    <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
    <span>Back To Person</span>
  </button>
  <span class="spacer"></span>
  <h3 class="toolbarLabel">Groups - {{ personName() }}</h3>
  <span class="spacer"></span>
</div>
@if (errorMessage()) {
  <div class="errorMessage">{{ errorMessage() }}</div>
}
<div class="groupsLayout">
  <div class="groupColumn">
    <div class="groupsHeader">Available Groups ({{ availableGroups().length }})</div>
    <input class="filterInput" placeholder="Filter" [value]="availableFilter()" (input)="onAvailableFilter($event)" />
    <div class="groupList">
      @for (group of filteredAvailableGroups(); track group.id) {
        <div class="groupRow" [class.selectedRow]="isSelected(group)" [title]="group.description ?? ''" (click)="selectAvailableGroup(group)" (dblclick)="addGroup()">
          {{ group.name + ' - ' + group.description }}
        </div>
      }
    </div>
  </div>
  <div class="buttonColumn">
    <button class="arrowButton" matButton="text" [disabled]="!canAdd()" (click)="addGroup()">
      <mat-icon class="size-16">keyboard_arrow_right</mat-icon>
    </button>
    <button class="arrowButton" matButton="text" [disabled]="!canRemove()" (click)="removeGroup()">
      <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
    </button>
  </div>
  <div class="groupColumn">
    <div class="groupsHeader">Assigned Groups ({{ assignedGroups().length }})</div>
    <input class="filterInput" placeholder="Filter" [value]="assignedFilter()" (input)="onAssignedFilter($event)" />
    <div class="groupList">
      @for (group of filteredAssignedGroups(); track group.id) {
        <div class="groupRow" [class.selectedRow]="isSelected(group)" [title]="group.description ?? ''" (click)="selectAssignedGroup(group)" (dblclick)="removeGroup()">
          {{ group.name + ' - ' + group.description }}
        </div>
      }
    </div>
  </div>
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <mat-progress-spinner diameter="24" mode="indeterminate"></mat-progress-spinner>
    <label class="busyLabel">Please Wait...</label>
  </div>
}
